import { Mapper } from '@Features/utils/prepareSearchCriterias';
import { SearchItemOperator } from '@Types/api/common/filters';
import { CompanyDict, TypeDict } from '@Types/index';
import { Currency } from '@Types/api/common/dictionary/Currency';
import { CostCenter } from '@Types/api/common/dictionary';

import { FilterForm } from './types';

export const initialValuesFilterForm: FilterForm = {
  dateFrom: '',
  dateTo: '',
  currencies: [],
  companies: [],
  mrFor: [],
  warranties: [],
  ccTypes: [],
  cCenters: [],
  statuses: [],
};

export const filterTypes: Record<
  keyof typeof initialValuesFilterForm,
  SearchItemOperator
> = {
  dateFrom: 'ge',
  dateTo: 'le',
  currencies: 'in',
  companies: 'in',
  mrFor: 'in',
  warranties: 'in',
  ccTypes: 'in',
  cCenters: 'in',
  statuses: 'in',
};

export const getFiltersMapper =
  (
    statuses: TypeDict[],
    costCenterTypesOptions: TypeDict[],
    companies: CompanyDict[],
    currencies: Currency[],
    mrForTypes: TypeDict[],
    warranties: TypeDict[],
    costCenters: CostCenter[]
  ): Mapper =>
  (key, value) => {
    if (key === 'dateFrom') {
      return ['createdOn', value];
    }

    if (key === 'dateTo') {
      return ['createdOn', value];
    }

    if (key === 'currencies') {
      const currencyIds = (value as string[]).map(
        (item) =>
          currencies.find((currency) => currency.currencyCode === item)!
            .currencyId
      );
      return ['currency', currencyIds];
    }

    if (key === 'companies') {
      const companyIds = (value as string[]).map(
        (item) => companies.find((company) => company.compName === item)!.compId
      );
      return ['compId', companyIds];
    }

    if (key === 'mrFor') {
      const mrForIds = (value as string[]).map(
        (item) => mrForTypes.find((mrFor) => mrFor.codeDesc === item)!.codeNum
      );
      return ['mrFor', mrForIds];
    }

    if (key === 'ccTypes') {
      const costCenterTypes = (value as string[]).map(
        (item) =>
          costCenterTypesOptions.find((ccType) => ccType.codeDesc === item)!
            .codeNum
      );
      return ['ccTypeId', costCenterTypes as number[]];
    }

    if (key === 'cCenters') {
      const costCenterIds = (value as string[]).map(
        (item) => costCenters.find((cCenter) => cCenter.name === item)!.id
      );
      return ['ccId', costCenterIds];
    }

    if (key === 'warranties') {
      const warrantyIds = (value as string[]).map(
        (item) =>
          warranties.find((warranty) => warranty.codeDesc === item)!.codeNum
      );
      return ['warrantyTypeId', warrantyIds];
    }

    const statusResultValue = (value as string[]).map(
      (item) => statuses.find((status) => status.codeDesc === item)!.codeNum
    );
    return ['statusId', statusResultValue];
  };
